module.exports = __webpack_public_path__ + "static/img/dataAssistant.4e07b15d.png";